<div class="mx-auto max-w-(--breakpoint-2xl) ">
  <!-- Loading overlay -->
  @if (loading) {
    <div class="absolute inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-sm rounded-2xl">
      <div class="flex flex-col items-center space-y-3 bg-white dark:bg-gray-800 px-6 py-4 rounded-lg shadow-lg">
        <div class="animate-spin h-6 w-6 border-3 border-blue-500 border-t-transparent rounded-full"></div>
      </div>
    </div>
  }

  @if (eventsPage) {
    <app-data-table
      (route)="this.handleRoute($event)"
      [title]="'Events'"
      [dataPage]="eventsPage"
      [columns]="tableColumns"
      [rowRouterLinkTemplate]="'/events/:id'"
      [rowActions]="rowActions">
      <div header class="flex flex-row w-full items-end gap-3">
        <app-text-input [control]="searchControl" [placeholder]="'Search by name, reference, or venue'" [label]="'Event Name'" [clearable]="true"></app-text-input>
        <div class="w-60">
          <app-date-picker [control]="startDateControl" label="From Date"></app-date-picker>
        </div>
        <div class="w-60">
          <app-date-picker [control]="endDateControl" label="To Date"></app-date-picker>
        </div>
        <app-button
          [label]="'Search'"
          [style]="'primary'"
          [icon]="SearchIcon"
          (click)="performSearch()">
        </app-button>
        <!-- TVG-152: CSV export runs as a background job; the button queues it and
             a download link appears once the file is ready. Gated behind the
             "event-export" toggle. -->
        @if (exportEnabled) {
          <app-button
            [label]="exporting ? 'Preparing…' : 'Export CSV'"
            [style]="'secondary'"
            [icon]="DownloadIcon"
            [disabled]="exporting"
            (click)="exportCsv()">
          </app-button>
          @if (exportReady) {
            <app-button
              [label]="'Download CSV'"
              [style]="'primary'"
              [icon]="DownloadIcon"
              (click)="downloadReadyExport()">
            </app-button>
          }
        }
        <!-- VG-380: Managers can create events for their venues; staff cannot -->
        @if (canCreateEvents) {
          <a routerLink="/events/create"
             class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 font-medium
            text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 whitespace-nowrap ml-auto">
            <lucide-icon [name]="PlusIcon"></lucide-icon>
            Add Event
          </a>
        } @else {
          <button
            class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5 font-medium text-gray-400 cursor-not-allowed whitespace-nowrap ml-auto"
            disabled
            title="Only admins or managers can add events">
            <lucide-icon [name]="PlusIcon"></lucide-icon>
            Add Event
          </button>
        }
      </div>
    </app-data-table>
  }

  <app-modal
    [title]="'Delete Event'"
    [content]="'Are you sure you want to delete this event? This action cannot be undone.'"
    [show]="isDeleteModalOpen"
    [closeButtonLabel]="'Cancel'"
    [confirmButtonLabel]="'Delete'"
    [processing]="isDeleting"
    (onClose)="isDeleteModalOpen = false"
    (onConfirm)="confirmDelete()">
  </app-modal>
</div>
